export const themesContext = require.context(".", true, /\_controller.js$/)
